module.exports = __webpack_public_path__ + "static/media/Label_App_Store.db219737.png";